import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useOnboarding } from '../../contexts/OnboardingContext';
import './JobPreviewModal.css';

function JobPreviewModal({ isOpen, onClose }) {
  const navigate = useNavigate();
  const { getJobRecommendations } = useOnboarding();
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showConfetti, setShowConfetti] = useState(true);

  useEffect(() => {
    if (isOpen) {
      loadJobs();
      // Hide confetti after animation
      const timer = setTimeout(() => setShowConfetti(false), 3000);
      return () => clearTimeout(timer);
    }
  }, [isOpen]);

  const loadJobs = async () => {
    setLoading(true);
    const result = await getJobRecommendations();
    setJobs(result.jobs || []);
    setLoading(false);
  };

  const handleViewJobs = () => {
    navigate('/discover-jobs');
  };

  const handleGoToDashboard = () => {
    navigate('/dashboard');
  };

  if (!isOpen) return null;

  return (
    <div className="job-preview-overlay">
      {/* Confetti animation */}
      {showConfetti && (
        <div className="confetti-container">
          {[...Array(50)].map((_, i) => (
            <div
              key={i}
              className="confetti"
              style={{
                left: `${Math.random() * 100}%`,
                animationDelay: `${Math.random() * 2}s`,
                backgroundColor: ['#6366F1', '#22D3EE', '#F59E0B', '#10B981'][Math.floor(Math.random() * 4)],
              }}
            />
          ))}
        </div>
      )}

      <div className="job-preview-modal">
        <div className="modal-header">
          <div className="success-icon">
            <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
              <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="3"/>
              <path d="M15 24L21 30L33 18" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          <h2>You're All Set!</h2>
          <p>Your profile is ready. Here are some jobs we think you'd love.</p>
        </div>

        <div className="jobs-container">
          {loading ? (
            <div className="jobs-loading">
              <div className="loading-spinner" />
              <p>Finding jobs for you...</p>
            </div>
          ) : jobs.length > 0 ? (
            <div className="jobs-list">
              {jobs.map((job, index) => (
                <div key={job.id || index} className="job-card">
                  <div className="job-logo">
                    {job.company.charAt(0).toUpperCase()}
                  </div>
                  <div className="job-info">
                    <h3 className="job-title">{job.title}</h3>
                    <p className="job-company">{job.company}</p>
                    <div className="job-meta">
                      <span className="job-location">
                        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                          <path d="M7 7.5C8.10457 7.5 9 6.60457 9 5.5C9 4.39543 8.10457 3.5 7 3.5C5.89543 3.5 5 4.39543 5 5.5C5 6.60457 5.89543 7.5 7 7.5Z" stroke="currentColor" strokeWidth="1.5"/>
                          <path d="M7 12.5C7 12.5 11.5 9.5 11.5 5.5C11.5 3.01472 9.48528 1 7 1C4.51472 1 2.5 3.01472 2.5 5.5C2.5 9.5 7 12.5 7 12.5Z" stroke="currentColor" strokeWidth="1.5"/>
                        </svg>
                        {job.location}
                      </span>
                      {job.remote && <span className="job-badge">Remote</span>}
                    </div>
                  </div>
                  <button className="job-action" onClick={() => navigate('/discover-jobs')}>
                    View
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <div className="no-jobs">
              <p>We're still finding the perfect matches for you.</p>
              <p>Check out all available jobs to get started!</p>
            </div>
          )}
        </div>

        <div className="modal-actions">
          <button className="action-btn primary" onClick={handleViewJobs}>
            View All Jobs
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
          <button className="action-btn secondary" onClick={handleGoToDashboard}>
            Go to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
}

export default JobPreviewModal;
